import { motion } from 'framer-motion';

export function TheShiftInterlude() {
  return (
    <div className="relative z-10 w-full py-16 bg-brand flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 opacity-20 mix-blend-overlay"></div>
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-black font-serif text-3xl md:text-5xl lg:text-7xl italic text-center px-4 tracking-tight leading-none"
      >
        Beyond the aesthetic, there is the architecture.
      </motion.h2>
    </div>
  );
}
